/* eslint-disable */
import { produce } from "immer";
import {
  ILLUSTRATION_FETCH_FAILURE,
  ILLUSTRATION_FETCH_SUCCESS,
  ILLUSTRATION_FETCH_START,
} from "../actions/types";

const viewIllustration = (
  state = {
    illustrationFetching: false,
    illustrationData: [],
    illustrationError: null,
  },
  action,
) => {
  switch (action.type) {
    case ILLUSTRATION_FETCH_START:
      return produce(state, (draft) => {
        draft.illustrationFetching = true;
      });
    case ILLUSTRATION_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.illustrationFetching = true;
        draft.illustrationData = action.data;
        draft.illustrationFetching = false;
      });
    case ILLUSTRATION_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.illustrationFetching = false;
        draft.illustrationError = action.error;
      });
    default:
      return state;
  }
};

export default viewIllustration;
